/**
 * Formateadores de moneda específicos de Flujo Semanal (locale es-CR).
 *
 * Nota: difiere a propósito del formato en-US de `formatearCRC`/`formatearUSD`
 * (usado por Vencimientos) — se trae tal cual de adelante-flujosemanal para no
 * alterar sus pantallas al fusionar. Unificar el formato visual entre ambos
 * módulos del portal queda como mejora pendiente, no parte de esta fusión.
 */
const fmtColones = new Intl.NumberFormat('es-CR', {
    style: 'currency',
    currency: 'CRC',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
});
const fmtDolares = new Intl.NumberFormat('es-CR', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});
export function formatearColones(monto) {
    return fmtColones.format(monto);
}
export function formatearDolares(monto) {
    return fmtDolares.format(monto);
}
//# sourceMappingURL=formatearMontoFlujo.js.map